(function () {

  var state = {
    product: null,
    selectedOptions: [],
    resolvedVariant: null
  };

  function getModal() {
    return {
      wrap:        document.querySelector('[data-upsell-modal]'),
      image:       document.querySelector('[data-upsell-modal-image]'),
      title:       document.querySelector('[data-upsell-modal-title]'),
      price:       document.querySelector('[data-upsell-modal-price]'),
      options:     document.querySelector('[data-upsell-modal-options]'),
      confirm:     document.querySelector('[data-upsell-modal-confirm]'),
      unavailable: document.querySelector('[data-upsell-modal-unavailable]')
    };
  }

  function getProductData(btn) {
    var card = btn.closest('.cart-drawer-upsell__card');
    if (!card) return null;
    var node = card.querySelector('[data-upsell-product-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function findVariant(product, selectedOptions) {
    return (product.variants || []).find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    }) || null;
  }

  function availableValuesForOption(product, optionIndex, selectedOptions) {
    var map = {};
    (product.variants || []).forEach(function (v) {
      var othersMatch = v.options.every(function (opt, i) {
        if (i === optionIndex) return true;
        return !selectedOptions[i] || selectedOptions[i] === opt;
      });
      if (othersMatch) {
        var val = v.options[optionIndex];
        map[val] = map[val] || v.available;
      }
    });
    return map;
  }

  // Encontra a imagem de uma variante de cor
  function getColorImage(product, colorValue, colorOptionIndex) {
    var variant = (product.variants || []).find(function (v) {
      return v.options[colorOptionIndex] === colorValue && v.image;
    });
    return variant ? variant.image : null;
  }

  function isColorOption(name) {
    var n = (name || '').toLowerCase();
    return n === 'color' || n === 'colour';
  }

  // ── Atualiza o estado visual SEM recriar o DOM ────────────────────────────
  function updateOptionsUI() {
    var m = getModal();
    if (!m.options || !state.product) return;

    var product = state.product;

    // Atualiza cada grupo já existente
    var groups = m.options.querySelectorAll('[data-option-group]');
    groups.forEach(function (group) {
      var optionIndex = parseInt(group.dataset.optionGroup, 10);
      var optionName  = product.options[optionIndex];
      var availMap    = availableValuesForOption(product, optionIndex, state.selectedOptions);
      var selected    = state.selectedOptions[optionIndex];

      // Atualiza label
      var labelEl = group.querySelector('.upsell-modal__option-label');
      if (labelEl) {
        labelEl.innerHTML = optionName + (selected ? ': <span>' + selected + '</span>' : '');
      }

      // Atualiza pills
      var pills = group.querySelectorAll('.upsell-modal__pill');
      pills.forEach(function (pill) {
        var val    = pill.dataset.optionValue;
        var avail  = availMap[val];
        pill.classList.toggle('is-selected', selected === val);
        pill.classList.toggle('is-unavailable', !avail);
      });
    });
  }

  // ── Renderiza opções pela primeira vez ────────────────────────────────────
  function renderOptions() {
    var m = getModal();
    if (!m.options || !state.product) return;

    var product = state.product;
    var options = product.options || [];
    m.options.innerHTML = '';

    options.forEach(function (optionName, optionIndex) {
      var allValues = [];
      (product.variants || []).forEach(function (v) {
        var val = v.options[optionIndex];
        if (allValues.indexOf(val) === -1) allValues.push(val);
      });

      var availMap = availableValuesForOption(product, optionIndex, state.selectedOptions);
      var selected = state.selectedOptions[optionIndex];
      var isColor  = isColorOption(optionName);

      var group = document.createElement('div');
      group.dataset.optionGroup = optionIndex;

      var labelEl = document.createElement('p');
      labelEl.className = 'upsell-modal__option-label';
      labelEl.innerHTML = optionName + (selected ? ': <span>' + selected + '</span>' : '');
      group.appendChild(labelEl);

      var pillsWrap = document.createElement('div');
      pillsWrap.className = 'upsell-modal__option-pills';

      allValues.forEach(function (val) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'upsell-modal__pill';
        pill.dataset.optionIndex = optionIndex;
        pill.dataset.optionValue = val;

        if (isColor) {
          // Pill com imagem da variante de cor
          pill.classList.add('upsell-modal__pill--color');
          var img = getColorImage(product, val, optionIndex);
          if (img) {
            pill.innerHTML = '<img src="' + img + '" alt="' + val + '"><span>' + val + '</span>';
          } else {
            pill.textContent = val;
          }
        } else {
          pill.textContent = val;
        }

        if (!availMap[val]) pill.classList.add('is-unavailable');
        if (selected === val) pill.classList.add('is-selected');

        pill.addEventListener('click', function (e) {
          e.stopPropagation(); // evita propagação pro backdrop
          if (!availMap[val]) return;
          state.selectedOptions[optionIndex] = val;
          updateOptionsUI();
          resolveVariant();
        });

        pillsWrap.appendChild(pill);
      });

      group.appendChild(pillsWrap);
      m.options.appendChild(group);
    });
  }

  function resolveVariant() {
    var m = getModal();
    if (!state.product) return;

    var allSelected = state.selectedOptions.length === state.product.options.length
      && state.selectedOptions.every(function (v) { return !!v; });

    if (!allSelected) {
      state.resolvedVariant = null;
      if (m.confirm) m.confirm.disabled = true;
      if (m.unavailable) m.unavailable.classList.remove('visible');
      return;
    }

    var variant = findVariant(state.product, state.selectedOptions);
    state.resolvedVariant = variant;

    if (!variant || !variant.available) {
      if (m.confirm) m.confirm.disabled = true;
      if (m.unavailable) m.unavailable.classList.add('visible');
    } else {
      if (m.confirm) m.confirm.disabled = false;
      if (m.unavailable) m.unavailable.classList.remove('visible');
      if (m.price) m.price.textContent = variant.price;

      // Atualiza imagem se a opção de cor estiver selecionada e tiver imagem
      var colorIdx = (state.product.options || []).findIndex(function (o) { return isColorOption(o); });
      if (colorIdx >= 0 && variant.image && m.image) {
        m.image.src = variant.image;
      }
    }
  }

  function openModal(product) {
    if (!product) return;
    state.product = product;
    state.selectedOptions = new Array(product.options.length).fill(null);
    state.resolvedVariant = null;

    var m = getModal();
    if (!m.wrap) return;

    if (m.image) { m.image.src = product.featured_image || ''; m.image.alt = product.title || ''; }
    if (m.title) m.title.textContent = product.title || '';
    if (m.price) m.price.textContent = '';
    if (m.confirm) { m.confirm.disabled = true; m.confirm.classList.remove('is-loading'); }
    if (m.unavailable) m.unavailable.classList.remove('visible');

    // Auto-seleciona primeira opção disponível de cada grupo
    (product.options || []).forEach(function (optName, optIndex) {
      var availMap   = availableValuesForOption(product, optIndex, state.selectedOptions);
      var firstAvail = Object.keys(availMap).find(function (v) { return availMap[v]; });
      if (firstAvail) state.selectedOptions[optIndex] = firstAvail;
    });

    renderOptions();
    resolveVariant();

    m.wrap.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    var m = getModal();
    if (m.wrap) m.wrap.hidden = true;
    document.documentElement.style.overflow = '';
    state.product = null;
    state.selectedOptions = [];
    state.resolvedVariant = null;
  }

  // ── Add to cart ───────────────────────────────────────────────────────────
  function addToCart(btn, variantId, closeAfter) {
    if (!variantId) return;
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding...'; }

    var sections = new Set();
    document.querySelectorAll('[data-section-id]').forEach(function (el) { sections.add(el.dataset.sectionId); });

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: Array.from(sections).join(','),
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
    .then(function (res) {
      if (!res.ok || res.data.status) throw new Error(res.data.message || 'Error');

      if (res.data.sections) {
        Object.values(res.data.sections).forEach(function (html) {
          var doc   = new DOMParser().parseFromString(html, 'text/html');
          var newEl = doc.querySelector('[data-cart-drawer-upsell]');
          var oldEl = document.querySelector('[data-cart-drawer-upsell]');
          if (newEl && oldEl) oldEl.replaceWith(newEl);
          else if (!newEl && oldEl) oldEl.remove();
        });
      }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { sourceId: 'cart-drawer-upsell', resource: res.data, data: { sections: res.data.sections || {} } }
      }));

      if (closeAfter) closeModal();
      scheduleRefresh();
    })
    .catch(function (err) {
      console.error('[Upsell]', err);
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = origText; }
    });
  }

  // ── Slider ────────────────────────────────────────────────────────────────
  function updateArrows(root) {
    if (!root) return;
    var vp     = root.querySelector('[data-upsell-viewport]');
    var slides = Array.from(root.querySelectorAll('[data-upsell-slide]'));
    var prev   = root.querySelector('[data-upsell-prev]');
    var next   = root.querySelector('[data-upsell-next]');
    if (!vp || !slides.length) return;
    var gap = parseFloat(window.getComputedStyle(vp).columnGap) || 10;
    var idx = Math.round(vp.scrollLeft / (slides[0].offsetWidth + gap));
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= slides.length - 1;
  }

  function scrollTo(root, idx) {
    var vp     = root.querySelector('[data-upsell-viewport]');
    var slides = Array.from(root.querySelectorAll('[data-upsell-slide]'));
    if (!vp || !slides.length) return;
    var gap = parseFloat(window.getComputedStyle(vp).columnGap) || 10;
    idx = Math.max(0, Math.min(idx, slides.length - 1));
    vp.scrollTo({ left: idx * (slides[0].offsetWidth + gap), behavior: 'smooth' });
    setTimeout(function () { updateArrows(root); }, 300);
  }

  function currentIdx(root) {
    var vp     = root.querySelector('[data-upsell-viewport]');
    var slides = Array.from(root.querySelectorAll('[data-upsell-slide]'));
    if (!vp || !slides.length) return 0;
    var gap = parseFloat(window.getComputedStyle(vp).columnGap) || 10;
    return Math.round(vp.scrollLeft / (slides[0].offsetWidth + gap));
  }

  function initSliders(scope) {
    scope = scope || document;
    Array.from(scope.querySelectorAll('[data-cart-drawer-upsell]')).forEach(function (root) {
      if (root.dataset.sliderReady === 'true') { updateArrows(root); return; }
      root.dataset.sliderReady = 'true';
      var vp = root.querySelector('[data-upsell-viewport]');
      if (vp) {
        var t;
        vp.addEventListener('scroll', function () {
          updateArrows(root);
          clearTimeout(t);
          t = setTimeout(function () { updateArrows(root); }, 120);
        }, { passive: true });
      }
      updateArrows(root);
    });
  }

  function scheduleRefresh() {
    [0, 80, 200, 400].forEach(function (d) {
      setTimeout(function () { initSliders(document); }, d);
    });
  }

  // ── Events ────────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-upsell-add]');
    if (addBtn) { e.preventDefault(); addToCart(addBtn, addBtn.dataset.variantId, false); return; }

    var modalBtn = e.target.closest('[data-upsell-open-modal]');
    if (modalBtn) { e.preventDefault(); openModal(getProductData(modalBtn)); return; }

    // Fecha só se clicar no backdrop diretamente
    if (e.target.matches('[data-upsell-close-modal]')) { e.preventDefault(); closeModal(); return; }

    var confirmBtn = e.target.closest('[data-upsell-modal-confirm]');
    if (confirmBtn) {
      e.preventDefault();
      if (state.resolvedVariant && state.resolvedVariant.available) {
        addToCart(confirmBtn, state.resolvedVariant.id, true);
      }
      return;
    }

    var prev = e.target.closest('[data-upsell-prev]');
    if (prev) { e.preventDefault(); var r = prev.closest('[data-cart-drawer-upsell]'); scrollTo(r, currentIdx(r) - 1); return; }

    var next = e.target.closest('[data-upsell-next]');
    if (next) { e.preventDefault(); var r2 = next.closest('[data-cart-drawer-upsell]'); scrollTo(r2, currentIdx(r2) + 1); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'cart-drawer-upsell') return;
    scheduleRefresh();
  });

  window.addEventListener('resize', scheduleRefresh);
  window.initUpsellSliders = initSliders;
  scheduleRefresh();

})();